import format from './format';
import { getConfig } from '../../configuration';
export default {
  key: 'console',
  check: () => true,
  init: () => {},
  handle: (level, message, data) => {
    const productId = getConfig('productId');
    const additionnalData = {
      ...data
    };
    if (productId) {
      additionnalData.productId = productId;
    }
    console[level](format(message), additionnalData);
  }
};